import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

const GlobalStyle = createGlobalStyle`
    ${reset}
    
    /* Paperlogy 폰트 */
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-1Thin.ttf') format('truetype');
        font-weight: 100;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-2ExtraLight.ttf') format('truetype');
        font-weight: 200;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-3Light.ttf') format('truetype');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-4Regular.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-5Medium.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-6SemiBold.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-7Bold.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-8ExtraBold.ttf') format('truetype');
        font-weight: 800;
        font-style: normal;
    }
    @font-face {
        font-family: 'Paperlogy';
        src: url('/font/paperlogy/Paperlogy-9Black.ttf') format('truetype');
        font-weight: 900;
        font-style: normal;
    }

    /* ComputerLaundry 폰트 */
    @font-face {
        font-family: 'ComputerLaundry';
        src: url('/font/computerlaundry/210computerL.ttf') format('truetype');
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: 'ComputerLaundry';
        src: url('/font/computerlaundry/210computerR.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: 'ComputerLaundry';
        src: url('/font/computerlaundry/210computerB.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
    }

    :root {
        --primary-color: #004094;
        --secondary-color: #666666;
        --accent-color: #004094;
        --background-color: #FFFFFF;
        --light-bg: #F9F9F9;
        --text-color: #333;
        --border-color: #E2E2E2;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        scroll-snap-type: y mandatory;
        overflow-y: scroll;
        height: 100%;
        -webkit-text-size-adjust: 100%;

        @media only screen and (max-width: 768px) {
            scroll-snap-type: none;
        }
    }
    
    body {
        font-family: "Paperlogy", sans-serif;
        font-weight: 300; /* Paperlogy-3Light */
        line-height: 1.7;
        color: #333;
        background-color: #f4f4f4;
        height: 100%;
        padding-top: 90px;
        
        @media only screen and (max-width: 768px) {
            padding-top: 60px;
        }
    }
    
    /* 폰트 패밀리 유틸리티 클래스 */
    .font-paperlogy {
        font-family: "Paperlogy", sans-serif;
    }
    
    .font-computer-laundry {
        font-family: "ComputerLaundry", monospace;
    }

    .header,
    section,
    .footer {
        scroll-snap-align: start;
        scroll-margin-top: 90px;
        
        @media only screen and (max-width: 768px) {
            scroll-margin-top: 60px;
            scroll-snap-align: none;
        }
    }
    
    a {
        text-decoration: none;
        color: inherit;
        transition: 0.3s;
    }
    
    ul {
        list-style: none;
    }

    h1, h2, h3, h4, h5, h6,
    .font-bold, .section-title, .slide-title, .about-main-title,
    .btn-slide, .col-title, .tab-btn, .col-cate, .col-preacher,
    .footer-logo, .tag-badge, .info-label, .contact-label,
    .worship-cate, .section-title-eng, .bank-name, .bank-num,
    .sns-link {
        font-family: "Paperlogy", sans-serif;
        font-weight: 700 !important; /* Paperlogy-7Bold */
    }
    
    .logo-kor, .logo-eng {
        font-family: "ComputerLaundry", monospace;
        font-weight: 400 !important; /* ComputerLaundry Regular */
    }

    .gnb-item {
        font-weight: 300 !important;
    }
`;

export default GlobalStyle;
